import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import axiosInstance, { GatewaySessionUrl, IAMUrl, switchIdentityUrl } from './util.js';

var getBaseUrl = function getBaseUrl(hostUrl, endPrefixUrl) {
  return hostUrl ? "".concat(hostUrl).concat(endPrefixUrl) : "".concat(endPrefixUrl);
};
var getCsrfToken = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(hostUrl) {
    var url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          url = getBaseUrl(hostUrl, GatewaySessionUrl);
          return _context.abrupt("return", axiosInstance.get(url).then(function (response) {
            return response.headers['x-il-csrf-token'];
          }));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getCsrfToken(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getAllListIdentities = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(hostUrl) {
    var token, url;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return getCsrfToken(hostUrl);
        case 2:
          token = _context2.sent;
          url = getBaseUrl(hostUrl, IAMUrl);
          return _context2.abrupt("return", axiosInstance.get(url, {
            headers: {
              'x-il-csrf-token': token
            }
          }).then(function (response) {
            return response.data.data;
          })["catch"](function (err) {
            throw err;
          }));
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getAllListIdentities(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var OnSwitchIdentity = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(Request, hostUrl) {
    var token, url;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getCsrfToken(hostUrl);
        case 2:
          token = _context3.sent;
          url = getBaseUrl(hostUrl, switchIdentityUrl);
          _context3.next = 6;
          return axiosInstance.put(url, Request, {
            headers: {
              'x-il-csrf-token': token
            }
          }).then(function (response) {
            return response.data.data;
          })["catch"](function (err) {
            throw err;
          });
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function OnSwitchIdentity(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

export { OnSwitchIdentity, getAllListIdentities, getCsrfToken };
